import { Network } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { LENDER_CATEGORIES } from "../../lib/data";

export const LenderNetwork = () => (
  <section id="lender-network" className="relative overflow-hidden bg-white py-24 md:py-32" data-testid="lender-network-section">
    <div className="pointer-events-none absolute -left-32 top-1/3 h-[380px] w-[380px] rounded-full bg-gold/8 blur-[150px]" />
    <div className="relative mx-auto max-w-7xl px-5 md:px-8">
      <div className="grid gap-14 lg:grid-cols-2 lg:gap-20">
        <div>
          <SectionHeading
            overline="Lender Network"
            title="Connecting Opportunities with the Right Financial Ecosystem"
            testId="lender-heading"
          />
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-gray-600 md:text-lg">
              LendX operates within a broad financial ecosystem and helps clients explore suitable financing options based on their requirements, eligibility, asset profile, and transaction structure.
            </p>
            <p className="mt-5 flex items-start gap-3 text-xs leading-relaxed text-gray-500">
              <Network size={14} className="mt-0.5 shrink-0 text-gold-deep" />
              Lender names and logos are displayed only with official authorization. LendX does not claim partnership with any bank or NBFC unless officially confirmed.
            </p>
          </Reveal>
        </div>
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-gray-200 bg-gray-200">
          {LENDER_CATEGORIES.map((c, i) => (
            <Reveal key={c} delay={(i % 4) * 0.06} y={24}>
              <div
                className="flex h-full min-h-[110px] items-center justify-center bg-white p-6 text-center transition-colors duration-500 hover:bg-gold-tint"
                data-testid={`lender-category-${i + 1}`}
              >
                <span className="font-heading text-sm font-semibold tracking-wide text-gray-700 md:text-base">{c}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
